import { createSelector } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseAsyncValue } from '../../../shared/models/async-value';
import { getOneClickResult } from '../../selectors/one-click-orders.selector';
import { getOneClickContractTypeSelected } from '../../selectors/one-click-contract.selector';
import { OneClickContractType } from '../../models/one-click-contract.model';

const resultAndContractType = createSelector(
  getOneClickResult,
  getOneClickContractTypeSelected,
  (result, contractType) => ({ result, contractType }),
);

export class OneClickAdditionalServicesDisplayerProvider extends BaseAsyncValue<boolean> {
  getValue(): Observable<boolean> {
    return this.store.select(resultAndContractType).pipe(
      map(({ result, contractType }) => {
        if (!result) {
          return contractType[this.mapItem['index']] !== OneClickContractType.Contract;
        }
        return true;
      }),
    );
  }
}
